import { useNavigate } from 'react-router'

export default function BillingCancel() {
  const navigate = useNavigate()
  return (
    <div style={{ padding: '80px 0' }}>
      <div className="container" style={{ maxWidth: 480 }}>
        <div className="eyebrow" style={{ marginBottom: 14 }}><span className="num">$</span>billing</div>
        <h1 className="h1">Payment canceled.</h1>
        <p className="lede" style={{ marginTop: 14, marginBottom: 28 }}>
          No charge was made. You can upgrade any time from the pricing page.
        </p>
        <div className="row gap-12">
          <button className="btn btn-primary" onClick={() => navigate('/pricing')}>
            View pricing →
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/workspace')}>
            Back to workspace
          </button>
        </div>
      </div>
    </div>
  )
}
